export default __webpack_public_path__ + "static/Digital_mainstreet-a3a6b00decc808d35451c8d6c097d6b7.mp4";